<template>
  <v-dialog
    v-model="show"
    max-width="650px"
    @click:outside="$emit('click:outside')"
  >
    <v-card :loading="dialogDeleteProcessing">
      <v-card-title class="headline">
        Are you sure you want to delete {{ editedItem.employer_name }}?
      </v-card-title>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="blue darken-1"
          text
          :disabled="dialogDeleteProcessing"
          @click="close"
        >
          Cancel
        </v-btn>
        <v-btn
          color="red"
          text
          :disabled="dialogDeleteProcessing"
          @click="deleteItemConfirm"
        >
          OK
        </v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'BadEmployerDeleteModal',

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    editedItem: {
      type: Object,
      default() {
        return {
          id: null,
          employer_name: '',
        };
      },
    },

  },

  data() {
    return {
      dialogDeleteProcessing: false,
    };
  },

  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  methods: {
    ...mapActions('notification', ['setNotification']),

    close() {
      this.$emit('close-modal');
    },

    deleteItemConfirm() {
      this.dialogDeleteProcessing = true;

      this.$axios
        .delete(`api/v1/bad-employer/${this.editedItem.id}`)
        .then(() => {
          this.$emit('item-deleted');

          this.setNotification({
            message: 'Bad Employer has been deleted.',
            color: 'green',
          });
        })

        .catch(() => {
          this.setNotification({
            message: 'There was an error processing your request.',
            color: 'red',
          });
        })

        .then(() => {
          this.dialogDeleteProcessing = false;

          this.close();
        });
    },
  },
};
</script>

<style scoped>

</style>
